module.exports = __webpack_public_path__ + "static/img/carousel_5.d0a70c19.jpg";